import { render } from "./LevelTwo.vue?vue&type=template&id=ad49668e&ts=true"
import script from "./LevelTwo.ts?vue&type=script&lang=ts&external"
export * from "./LevelTwo.ts?vue&type=script&lang=ts&external"

import "./LevelTwo.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__